import * as actionTypes from "../actions/actionTypes";

const INITIAL_STATE = {
  locationModalVisible: false,
  isLoading: true,
  locationList: [],
  storeLocation: {
    data: {},
    success: false
  }
};

export default function locationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.SHOW_MODAL_LOCATION:
      // let storeLocation = { ...state.storeLocation };
      // storeLocation.isFirstLoad = false;
      return {
        ...state,
        locationModalVisible: true
        // storeLocation:storeLocation
      };
    case actionTypes.HIDE_MODAL_LOCATION:
      return {
        ...state,
        locationModalVisible: false
      };
    case actionTypes.GET_LOCATION:
      return {
        ...state
        // locationModalVisible: true
      };
    case actionTypes.GET_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        locationList: action.data.data
      };
    case actionTypes.STORE_LOCATION:
      return {
        ...state,
        storeLocation: {
          data: {},
          success: false
        }
      };
    case actionTypes.STORE_LOCATION_SUCCESS:
      return {
        ...state,
        locationModalVisible: false,
        storeLocation: {
          data: action.data,
          success: true
        }
      };

    default:
      return state;
  }
}
